<template>
  <div>
    <div>
      <el-input type="text" v-model="search.keyword"></el-input>
      <el-button @click="skipPage(1)">搜索</el-button>
      <el-button @click="openAddDialog">新增企业</el-button>
    </div>

    <div>
      <p v-for="corp in page.rows" :key="'corp_' + corp.id">
        <span>{{corp.corpName}}</span>&nbsp;
        <a href="javascript:void(0)" @click="details(corp.id)">详情</a>&nbsp;
        <a href="javascript:void(0)" @click="openPasswordDialog(corp)">重置密码</a>
      </p>

    </div>
<!--   分页     -->
    <el-pagination :total="page.total"
                   :page-size="page.size"
                   :current-page="page.current"
                   @current-change="skipPage">
    </el-pagination>

<!--  新增企业dialog  -->
    <el-dialog title="新增企业" :visible.sync="addDialog.visible" :close-on-click-modal="false">
      <div>
        <p>企业名称<el-input type="text" v-model="addDialog.form.corpName"></el-input></p>
        <p>企业代码<el-input type="text" v-model="addDialog.form.corpCode"></el-input></p>
        <p>企业LOGO<input type="file"/></p>
        <p>联系人姓名<el-input type="text" v-model="addDialog.form.contactsName"></el-input></p>
        <p>联系人电话<el-input type="text" v-model="addDialog.form.contactsTel"></el-input></p>
        <p>联系人手机<el-input type="text" v-model="addDialog.form.contactsMobile"></el-input></p>
        <p>注册地址<el-input type="text" v-model="addDialog.form.address"></el-input></p>
        <p>管理员账户<el-input type="text" v-model="addDialog.form.adminAccount"></el-input></p>
        <p>管理员密码<el-input type="password" v-model="addDialog.form.adminPassword"></el-input></p>
        <p>确认管理员密码<el-input type="password" v-model="addDialog.form.adminPasswordConfirm"></el-input></p>
        <p>管理员姓名<el-input type="text" v-model="addDialog.form.adminNickname"></el-input></p>
      </div>
      <div>
        <el-button @click="doAddCorp">保存</el-button>
      </div>
    </el-dialog>

<!--  重置密码  -->
    <el-dialog title="重置企业管理员密码"
               :visible.sync="passwordDialog.visible"
               :close-on-click-modal="false">
      <p>{{passwordDialog.corpName}}</p>
      新密码<el-input type="password" v-model="passwordDialog.form.password"></el-input>
      确认新密码<el-input type="password" v-model="passwordDialog.form.passwordConfirm"></el-input>
      <div slot="footer">
        <el-button @click="doResetPassword()">确定</el-button>
        <el-button @click="passwordDialog.visible=false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="企业详情" :visible.sync="detailDialog.visible">

      {{detailDialog.item}}

    </el-dialog>

  </div>
</template>

<script>
import base from "../../../api/common";
import qs from "qs"
export default {
  name: "corpList",
  data(){
    return{
      page: {
        current: 1,
        size: 10,
        total: 8,
        rows: []
      },
      search:{
        keyword: ''
      },
      addDialog:{
        visible: false,
        form:{
          corpName: '',
          corpCode: '',
          corpLogo: '',
          contactsTel: '',
          contactsName: '',
          contactsMobile: '',
          address: '',
          adminAccount: '',
          adminPassword: '',
          adminPasswordConfirm: '',
          adminNickname: '',
        }
      },
      passwordDialog:{
        visible: false,
        corpName: '',
        form:{
          id: 0,
          password: '',
          passwordConfirm: ''
        }
      },
      detailDialog:{
        visible: false,
        item:{}
      }
    }
  },
  mounted() {
    this.skipPage(1);
  },
  methods:{
    skipPage(page){
      this.page.current = page;
      this.getData();
    },
    getData(){
      let params = {
        page: this.page.current,
        size: this.page.size,
        keyword: this.search.keyword
      };
      this.$ajax.post(base.basePath + 'corp/corp-company/admin/page',params).then(res=>{
        if(res.data.status === 'success'){
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        this.$message.error('数据加载失败');
      })
    },
    openAddDialog(){
      this.addDialog.form.corpName = '';
      this.addDialog.form.corpCode = '';
      this.addDialog.form.corpLogo = '';
      this.addDialog.form.contactsTel = '';
      this.addDialog.form.contactsName = '';
      this.addDialog.form.contactsMobile = '';
      this.addDialog.form.address = '';
      this.addDialog.form.adminAccount = '';
      this.addDialog.form.adminPassword = '';
      this.addDialog.form.adminNickname = '';
      this.addDialog.visible = true;
    },
    doAddCorp(){
      // 字段验证
      if($.trim(this.addDialog.form.corpName).length===0){ this.$message.error('企业名称不能为空'); return; }
      if($.trim(this.addDialog.form.corpCode).length===0){ this.$message.error('企业代码不能为空'); return; }
      if($.trim(this.addDialog.form.adminAccount).length===0){ this.$message.error('企业管理员账户不能为空'); return; }
      if($.trim(this.addDialog.form.adminPassword).length===0){ this.$message.error('企业管理员密码不能为空'); return; }
      if(this.addDialog.form.adminPassword != this.addDialog.form.adminPasswordConfirm){
        this.$message.error('两次输入的密码不一致');
        return;
      }
      if($.trim(this.addDialog.form.adminNickname).length===0){ this.$message.error('企业管理员名称不能为空'); return; }

      let data = {
        corpName: this.addDialog.form.corpName,
        corpCode: this.addDialog.form.corpCode,
        contactsTel: this.addDialog.form.contactsTel,
        contactsName: this.addDialog.form.contactsName,
        contactsMobile: this.addDialog.form.contactsMobile,
        address: this.addDialog.form.address,
        adminAccount: this.addDialog.form.adminAccount,
        adminPassword: this.addDialog.form.adminPassword,
        adminNickname: this.addDialog.form.adminNickname
      };
      this.$ajax.post(base.basePath + 'corp/corp-company/admin/add',data).then(res=>{
        if(res.data.status === 'success'){
          this.$message.success('添加成功');
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        this.$message.error('添加失败');
      })
    },
    openPasswordDialog(corp){
        this.passwordDialog.corpName = corp.corpName;
        this.passwordDialog.visible = true;
        this.passwordDialog.form.id = corp.id;
        this.passwordDialog.form.password = '';
        this.passwordDialog.form.passwordConfirm = '';
    },
    doResetPassword(){
      let password = this.passwordDialog.form.password;
      let id = this.passwordDialog.form.id;
      if($.trim(password).length < 6 || $.trim(password).length > 16){
        this.$message.error('新密码长度6-16位');
        return;
      }
      if(this.passwordDialog.form.passwordConfirm != password){
        this.$message.error('两次输入的密码不一致');
        return;
      }
      this.$ajax.post(base.basePath + 'corp/corp-company/admin/reset-password/' + id,qs.stringify({password})).then(res=>{
        if(res.data.status === 'success'){
          this.$message.success('重置成功');
          this.passwordDialog.visible = false;
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        this.$message.error('操作失败');
      });
    },
    details(id){
      this.$ajax.post(base.basePath + 'corp/corp-company/admin/details/' + id).then(res=>{
        if(res.data.status === 'success'){
          this.detailDialog.item = res.data.data;
          this.detailDialog.visible = true;
        }else{
          this.$message.error(res.data.message);
        }
      }).catch(err=>{
        console.error(err);
        this.$message.error('信息加载失败');
      })
    }
  }
}
</script>

<style scoped>

</style>